import React, { createContext, useContext } from "react";
import { Navigate } from "react-router-dom";
import { getAccessByRole } from "../constants/roles";

// Context so any child component can read the logged-in user + their access config
export const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("isAdminAuthenticated") === "true";

  // console.log("[ProtectedRoute] isAuthenticated:", isAuthenticated);

  if (!isAuthenticated) {
    // console.warn("[ProtectedRoute] ⛔ Not authenticated — redirecting to login");
    return <Navigate to="/admin/login" replace />;
  }

  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("adminUser"));
    // console.log("[ProtectedRoute] User from localStorage:", user);
  } catch (e) {
    // console.error("[ProtectedRoute] Failed to parse adminUser from localStorage:", e);
  }

  const role = user?.role || null;
  const access = getAccessByRole(role);
  // console.log("[ProtectedRoute] Role:", role, "| Access:", access);

  return (
    <AuthContext.Provider value={{ user, role, access }}>
      {children}
    </AuthContext.Provider>
  );
};

export default ProtectedRoute;
